// Refetch the WMS product list every time a kept-alive page is activated again.
// Spec: docs/specs/2026-10-07-wms-product-active-design.md §7 F7 (issue #421).
//
// Pages that build rows / dropdowns from WmsProduct/getData load the list in
// mounted() only. The taskbar keeps them alive, so a product disabled or
// enabled from another browser tab (or by another user) stayed visible until
// a full reload. Modelled on refreshOnArrival.js, but without arrivalIntent:
// every switch back to the tab refetches (one GET, ~300 rows).
//
// The first activated() follows mounted() (which already loaded) and is
// skipped; every later activation calls this.refetchWmsProducts(). The default
// below calls the page's mapped `listProduct` ("WmsProduct/listData"); a page
// whose loader differs overrides refetchWmsProducts (component methods win
// over mixin methods). Vue merges a page's own created/activated after these.
//
// Consumers: Stock/InventoryTables.vue, InventoryIn.vue, InventoryOut.vue,
// InventoryTransfer.vue, InventoryTransferToLine.vue, InventoryDashboard.vue,
// InventoryDetailTables.vue, ProductTables.vue (override: current activeFilter).
// Pinned by tests/unit/wmsProductRefetchOnActivate.spec.js.
export default {
	created() {
		// Non-reactive on purpose: not in data(). Own name (not refreshOnArrival.js's
		// `activatedOnce`) so a page using both mixins does not share one flag.
		this.wmsProductActivatedOnce = false;
	},
	activated() {
		if (!this.wmsProductActivatedOnce) {
			this.wmsProductActivatedOnce = true; // first activation = mounted() already loaded
			return;
		}
		if (typeof this.refetchWmsProducts === "function") this.refetchWmsProducts();
	},
	methods: {
		refetchWmsProducts() {
			return this.listProduct && this.listProduct();
		}
	}
};
